@import '../../styles/modals.css';
@import '../../styles/buttons.css';
@import '../../styles/checkout-order-details.css';


:host{
  line-height: 1.2;
  font-weight: normal;
}

.duration {
  display: inline-flex;
  align-items: center;
  background: #e6e6e6;
  border-radius: 13px;
  padding: 3px;
  flex-shrink: 0;
}

.duration-button {
  width: 18px;
  height: 18px;
  font-size: 18px;
  font-weight: 500;

  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  flex-shrink: 0;
  box-sizing: border-box;

  color: #000;
  background-color: #fff;
  border: 1px solid #999;
  border-radius: 50%;
}

.duration-button:hover {
  background-color: #efefef;
}

.duration-button.disabled,
.duration-button.disabled:hover {
  background-color: #efefef;
  border: 1px solid #ccc;
  fill: #ccc;
}

.duration-button.active {
  cursor: pointer;
}

.duration-value {
  padding: 0px 5px;
  cursor: default;
  text-align: center;
  min-width: 60px;
}

.duration-value.long { min-width: 130px; }



.tambr-action-buttons { border-top: 1px solid #d5d9de; }


.values-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: stretch;
}

.value-button {
  position: fixed;
  opacity: 0;
  pointer-events: none;
}

.value-button + label {
  padding: 4px 8px;
  cursor: pointer;
  background-color: #fff;
  width: 70px;
  vertical-align: middle;
  text-align: center;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.value-button:checked + label {
  background-color: #e6e6e6;
}